export default __webpack_public_path__ + "static/part3_5-8d437a1dc6ee5e02a27069478ad6296e.png";